import { AppBarPositionEnum } from './interfaces';

export const getButtonPosition = (
  position: AppBarPositionEnum,
): 'left' | 'right' => {
  switch (position) {
    case AppBarPositionEnum.TopRight:
    case AppBarPositionEnum.BottomRight:
      return 'right';
    default:
      return 'left';
  }
};
